import React, { useEffect, useState, useRef } from 'react';
import { useAuthStore } from '../../../store/authStore';
import { useChatStore } from '../../../store/chat_store';
import { getConversations, getMessages } from '../../../services/chat_service';
import ChatSidebar from '../components/ChatSidebar';
import ChatHeader from '../components/ChatHeader';
import MessageList from '../components/MessageList';
import MessageInput from '../components/MessageInput';
import api from '../../../services/api';
import { X } from 'lucide-react';

export const ChatOverlay = ({ onClose }) => {
  const { user } = useAuthStore();
  const { initSocket, disconnectSocket, setConversations, activeConversation, setMessages } = useChatStore();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (user) {
      initSocket(user._id || user.id);
      fetchInitialData();
    }
    return () => {
      // Don't disconnect socket if we want to keep receiving messages in background
      // disconnectSocket(); 
    };
  }, [user, initSocket]);

  const lastLoadedUserIdRef = useRef(null);

  useEffect(() => {
    const otherUserId = activeConversation?.otherUserId;
    // Only fetch if the OTHER USER changed — not on every activeConversation update
    if (otherUserId && otherUserId !== lastLoadedUserIdRef.current) {
      lastLoadedUserIdRef.current = otherUserId;
      loadMessages(otherUserId);
    }
  }, [activeConversation?.otherUserId]);

  const fetchInitialData = async () => {
    try {
      const resConv = await getConversations();
      if (resConv.status === 'success') {
        setConversations(resConv.data);
      }
      
      const resUsers = await api.get('/teams?limit=1000'); 
      if (resUsers.data?.success || resUsers.data?.status === 'success') {
        setUsers(resUsers.data.data || resUsers.data.data.users);
      }
    } catch (error) {
      console.error('Failed to load chat data', error);
    }
  };

  const loadMessages = async (otherUserId) => {
    try {
      const res = await getMessages(otherUserId);
      if (res.status === 'success') {
        setMessages(res.data.messages);
        // Update conversationId without triggering the otherUserId watcher
        const current = useChatStore.getState().activeConversation;
        if (current && !current.conversationId && res.data.conversation_id) {
          useChatStore.setState({
            activeConversation: {
              ...current,
              conversationId: res.data.conversation_id
            }
          });
        }
      }
    } catch (error) {
      console.error('Failed to load messages', error);
    }
  };

  return (
    <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden flex z-[9999]">
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 z-50 p-2 bg-white/80 hover:bg-gray-100 rounded-full text-gray-500 shadow-sm border border-gray-100"
      >
        <X size={18} />
      </button>

      <ChatSidebar users={users} />
      <div className="flex-1 flex flex-col h-full bg-white relative">
        {activeConversation ? (
          <>
            <ChatHeader />
            <MessageList />
            <MessageInput />
          </>
        ) : (
          <div className="flex-1 flex flex-col items-center justify-center text-gray-400 bg-gray-50 h-full">
            <span className="text-4xl mb-4">💬</span>
            <p>Select a conversation to start chatting</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatOverlay;
